// V1.5+ forward turret network dependency per docs/02_GAME_DESIGN.md §15
// "Forward turrets only operate at full power if connected to the player's
// signal network." A `mini_turret` (Engineer's Q deploy) requires an
// owned-by-its-owner ControlNode marked `isConnected: true` within
// FORWARD_TURRET_RANGE_PX of the turret to stay online. Below: turret goes
// dark — no firing, no vision. Reconnects when the network is restored.
//
// Calibration for the Foundry layout (mirrored 2000×2000 grid):
//   - Spawn → nearest relay ≈ 380 px (Cores at y=220/1780, edge relays at
//     y=600/1400).
//   - Mid relay → either spawn ≈ 1000 px.
//   - Recon vision ≈ 700 px (14 tiles × 50 px).
//   - Mini-turret default range ≈ 320 px (data/abilities.ts).
//
// 600 px is the design landing point: generous enough that an Engineer
// dropping a turret near a captured relay (within a Recon's vision band)
// keeps the network anchor without micrometric placement; tight enough that
// a turret pushed deep into enemy territory must commit to a captured
// forward relay to stay live. Exactly the forward-relay-pressure dynamic
// docs/02_GAME_DESIGN.md §15 spells out. Adjust during the bot-vs-bot
// telemetry pass if win-rates skew.
//
// Permanent turrets (`kind: 'turret'`) are NOT gated by this rule — Core-ring
// placement makes them inherently network-rooted (§15 "Core-adjacent
// defensive turrets always work"). ForwardTurretNetworkSystem keeps their
// `isOnline` flag true unconditionally.
export const FORWARD_TURRET_RANGE_PX = 600;
export const FORWARD_TURRET_RANGE_SQ = FORWARD_TURRET_RANGE_PX * FORWARD_TURRET_RANGE_PX;
